
export default function WhatWeDo() {
  return (
    <section id="services" className="bg-[#0A0A0A] py-16 sm:py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <div className="text-[8px] sm:text-[9px] uppercase tracking-[0.2em] text-[#606060] font-light mb-3 sm:mb-4">
            What We Provide
          </div>
          <h2 className="text-[32px] sm:text-[42px] md:text-[56px] font-bold text-[#F0F0F0] leading-tight font-serif mb-4 sm:mb-6 md:mb-8">
            Medical Security
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#A0A0A0] leading-relaxed max-w-[800px] mx-auto px-4 sm:px-0">
            We specialise in transforming your personal staff into a seamless first response unit, ensuring precision and readiness when it matters most.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 mb-12 sm:mb-16 md:mb-20">
          <div className="bg-[#0F0F0F] border border-[#1A1A1A] rounded-2xl p-6 sm:p-8 md:p-10 lg:p-12">
            <h3 className="text-xl sm:text-2xl md:text-[28px] font-semibold text-[#F5F5F5] mb-4 sm:mb-6">
              Bespoke Medical Security Solutions
            </h3>
            <p className="text-sm sm:text-base md:text-[16px] text-[#A0A0A0] leading-relaxed mb-4 sm:mb-6">
              We design and deliver medical security solutions across private aviation, superyachts, estates, executive travel, and sensitive operations worldwide.
            </p>
            <p className="text-sm sm:text-base md:text-[16px] text-[#A0A0A0] leading-relaxed">
              Our focus is not treatment, but <strong className="text-[#F5F5F5]">readiness</strong>—ensuring that when medical events occur, outcomes are controlled, coordinated, and decisive.
            </p>
          </div>

          <div className="bg-[#0F0F0F] border border-[#1A1A1A] rounded-2xl p-6 sm:p-8 md:p-10 lg:p-12">
            <h3 className="text-xl sm:text-2xl md:text-[28px] font-semibold text-[#F5F5F5] mb-4 sm:mb-6">
              Strategic Positioning
            </h3>
            <p className="text-sm sm:text-base md:text-[16px] text-[#A0A0A0] leading-relaxed mb-4 sm:mb-6">
              Our work sits at the intersection of medicine, risk management, and elite security—designed for principals and assets that require absolute preparedness, not visibility.
            </p>
            <p className="text-sm sm:text-base md:text-[16px] text-[#A0A0A0] leading-relaxed">
              We operate where failure carries life-critical, reputational, and continuity consequences.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
